module.exports = __webpack_public_path__ + "static/img/MARCUS-PRASAD.8523baf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MARCUS-PRASAD.jpg
// module id = Nejt
// module chunks = 0